// // // import React from 'react';
// // // import { useTranslation } from 'react-i18next';
// // // import { Link } from 'react-router-dom';
// // // import useGetSysCode from '../../hooks/useGetSysCode';

// // // interface BreadcrumbList {
// // //   name: any;
// // //   link: string | null;
// // // }

// // // interface Props {
// // //   BreadcrumbList: BreadcrumbList[];
// // //   PageName?: any;
// // //   subtitle?: any;
// // // }

// // // const Breadcrumb: React.FC<Props> = ({ BreadcrumbList, PageName, subtitle }) => {
// // //   const { t } = useTranslation();
// // //   const sysCode = useGetSysCode();

// // //   // دالة مساعدة لعرض المحتوى مع الترجمه إذا كان نصاً
// // //   const renderContent = (content: any) => {
// // //     if (typeof content === 'string') {
// // //       return t(content);
// // //     }
// // //     return content;
// // //   };

// // //   return (
// // //     <div className='d-flex align-items-center mb-3'>
// // //       <div>
// // //         <ul className='breadcrumb'>
// // //           <li className='breadcrumb-item bg-theme bg-opacity-40  fw-bold  rounded-2 px-3 '>{sysCode.name}</li>

// // //           {BreadcrumbList?.map((item, idx) => (
// // //             <li className='breadcrumb-item' key={idx}>
// // //               {item.link !== null ? (
// // //                 <Link to={item.link} replace>
// // //                   {t(item.name)}
// // //                 </Link>
// // //               ) : (
// // //                 t(item.name)
// // //               )}
// // //             </li>
// // //           ))}
// // //         </ul>

// // //         <h3 className=' mb-0'>
// // //           {/* {t(PageName)}{' '} */}
// // //           {renderContent(PageName)}{' '}
// // //           {subtitle && <small className='fs-6 p-0 m-0 bg-theme bg-opacity-15 rounded-2 px-1 '> {subtitle} </small>}
// // //         </h3>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default Breadcrumb;

// // import React from 'react';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import useGetSysCode from '../../hooks/useGetSysCode';

// // interface BreadcrumbListItem {
// //   name: any;
// //   link: string | null;
// // }

// // interface Props {
// //   BreadcrumbList: BreadcrumbListItem[];
// //   PageName?: any;
// //   subtitle?: any;
// // }

// // const Breadcrumb: React.FC<Props> = ({ BreadcrumbList, PageName, subtitle }) => {
// //   const { t } = useTranslation();
// //   const { moduleCode } = useGetSysCode();

// //   // دالة مساعدة لعرض المحتوى مع الترجمة إذا كان نصًا
// //   const renderContent = (content: any) => (typeof content === 'string' ? t(content) : content);

// //   return (
// //     <div className='d-flex align-items-center mb-3'>
// //       <div>
// //         <ul className='breadcrumb'>
// //           {/* إظهار كود الموديول الحالي */}
// //           <li className='breadcrumb-item bg-theme bg-opacity-40 fw-bold rounded-2 px-3'>{moduleCode}</li>

// //           {BreadcrumbList?.map((item, idx) => (
// //             <li className='breadcrumb-item' key={idx}>
// //               {item.link ? (
// //                 // لا نستخدم replace هنا حتى لا نكسر سجل الرجوع للخلف
// //                 <Link to={item.link}>{t(item.name)}</Link>
// //               ) : (
// //                 t(item.name)
// //               )}
// //             </li>
// //           ))}
// //         </ul>

// //         <h3 className='mb-0'>
// //           {renderContent(PageName)}{' '}
// //           {subtitle && (
// //             <small className='fs-6 p-0 m-0 bg-theme bg-opacity-15 rounded-2 px-1'> {subtitle} </small>
// //           )}
// //         </h3>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Breadcrumb;

// import React from 'react';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import useGetSysCode from '../../hooks/useGetSysCode';
// import type { ModuleCode } from '@modules/moduleRegistry';

// interface BreadcrumbListItem {
//   name: any;
//   link: string | null;
// }

// interface Props {
//   BreadcrumbList: BreadcrumbListItem[];
//   PageName?: any;
//   subtitle?: any;
// }

// // خريطة عناوين الموديولات → مفاتيح i18n
// const MODULE_TITLE_KEYS: Record<ModuleCode, string> = {
//   USER: 'welcome',
//   NTX: 'Settings',
//   HR: 'hr',
//   PAYROLL: 'payrollManagement',
//   RAQ: 'attendanceManagement',
//   AME: 'approvalsManagement',
//   FIN: 'financeManagement',
//   AP: 'payablesManagement',
//   AR: 'receivablesManagement',
//   INV: 'inventoryManagement',
//   PUR: 'purchaseManagement',
//   SAL: 'salesManagement',
//   ASSETS: 'assetsManagement',
//   POS: 'posManagement',
//   FLEET: 'fleetManagement',
//   SU: 'Propertymanagement',
//   RPT: 'reportsManagement',
//   NTF: 'notificationsSystem',
//   INT: 'integrationManagement',
//   MRP: 'mrpManagement' // تأكد من إضافة المفتاح في ملفات الترجمة أو سيظهر كما هو
// };

// const Breadcrumb: React.FC<Props> = ({ BreadcrumbList, PageName, subtitle }) => {
//   const { t } = useTranslation();
//   const { moduleCode } = useGetSysCode();

//   // اسم الموديول المعروض (مع الترجمة)
//   const moduleTitle = t(MODULE_TITLE_KEYS[moduleCode as ModuleCode] ?? (moduleCode as string));

//   const renderContent = (content: any) => (typeof content === 'string' ? t(content) : content);

//   return (
//     <div className='d-flex align-items-center mb-3'>
//       <div>
//         <ul className='breadcrumb'>
//           {/* اسم الموديول بدلًا من الكود */}
//           <li className='breadcrumb-item bg-theme bg-opacity-40 fw-bold rounded-2 px-3'>{moduleTitle}</li>

//           {BreadcrumbList?.map((item, idx) => (
//             <li className='breadcrumb-item' key={idx}>
//               {item.link ? <Link to={item.link}>{t(item.name)}</Link> : t(item.name)}
//             </li>
//           ))}
//         </ul>

//         <h3 className='mb-0'>
//           {renderContent(PageName)}{' '}
//           {subtitle && <small className='fs-6 p-0 m-0 bg-theme bg-opacity-15 rounded-2 px-1'> {subtitle} </small>}
//         </h3>
//       </div>
//     </div>
//   );
// };

// export default Breadcrumb;

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useGetSysCode from '../../hooks/useGetSysCode';
import { MODULE_BASE, type ModuleCode } from '@modules/moduleRegistry';

interface BreadcrumbListItem {
  name: any;
  link: string | null;
}

interface Props {
  BreadcrumbList: BreadcrumbListItem[];
  PageName?: any;
  subtitle?: any;
}

// خريطة عناوين الموديولات → مفاتيح i18n
const MODULE_TITLE_KEYS: Record<ModuleCode, string> = {
  USER: 'welcome',
  NTX: 'Settings',
  HR: 'hr',
  PAYROLL: 'payrollManagement',
  RAQ: 'attendanceManagement',
  AME: 'approvalsManagement',
  FIN: 'financeManagement',
  CASH: 'cashManagement',
  AP: 'payablesManagement',
  AR: 'receivablesManagement',
  INV: 'inventoryManagement',
  PUR: 'purchaseManagement',
  SAL: 'salesManagement',
  ASSETS: 'assetsManagement',
  POS: 'posManagement',
  FLEET: 'fleetManagement',
  SU: 'Propertymanagement',
  RPT: 'reportsManagement',
  NTF: 'notificationsSystem',
  INT: 'integrationManagement',
  MRP: 'mrpManagement' // تأكد من إضافة المفتاح في ملفات الترجمة أو سيظهر كما هو
  ,
  PROJECT: ''
};

// الرمز الوحيد المعتمد لصفحة هبوط الموديول
const MODULE_HOME_TOKEN = ':moduleHome';

const Breadcrumb: React.FC<Props> = ({ BreadcrumbList, PageName, subtitle }) => {
  const { t } = useTranslation();
  const { moduleCode } = useGetSysCode();

  const moduleTitle = t(MODULE_TITLE_KEYS[moduleCode as ModuleCode] ?? (moduleCode as string));
  const moduleHome = MODULE_BASE[moduleCode as ModuleCode] || '/';

  const resolveLink = (link: string | null) => {
    if (!link) return null;
    // اعتمد فقط الرمز ':moduleHome' بدون أي بدائل أخرى
    if (link.trim() === MODULE_HOME_TOKEN) return moduleHome;
    return link;
  };
  const renderContent = (content: any) => (typeof content === 'string' ? t(content) : content);

  return (
    <div className='d-flex align-items-center mb-3'>
      <div>
        <ul className='breadcrumb'>
          {/* اسم الموديول الحالي */}
          <li className='breadcrumb-item bg-theme bg-opacity-40 fw-bold rounded-2 px-3'>{moduleTitle}</li>

          {BreadcrumbList?.map((item, idx) => {
            const href = resolveLink(item.link);
            return (
              <li className='breadcrumb-item' key={idx}>
                {href ? <Link to={href}>{t(item.name)}</Link> : t(item.name)}
              </li>
            );
          })}
        </ul>

        <h3 className='mb-0'>
          {renderContent(PageName)}{' '}
          {subtitle && <small className='fs-6 p-0 m-0 bg-theme bg-opacity-15 rounded-2 px-1'> {subtitle} </small>}
        </h3>
      </div>
    </div>
  );
};

export default Breadcrumb;
